import { render, staticRenderFns } from "./EventTab.vue?vue&type=template&id=84e83166"
import script from "./EventTab.vue?vue&type=script&lang=js"
export * from "./EventTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports